import { render, staticRenderFns } from "./EditConfig.vue?vue&type=template&id=42f0807d&scoped=true&"
import script from "./EditConfig.vue?vue&type=script&lang=ts&"
export * from "./EditConfig.vue?vue&type=script&lang=ts&"
import style0 from "./EditConfig.vue?vue&type=style&index=0&id=42f0807d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0807d",
  null
  
)

export default component.exports